<mat-list [ngClass]="{'darkMode': darkModeService.darkMode}">
    <ng-container *ngFor="let url of organization?.urls">
        <mat-list-item *ngIf="url.id != 'Grafana' || (url.id === 'Grafana' && organization.grafana)">
            <button 
                mat-icon-button 
                (click)="goToUrl(url.value)"
                matTooltip="Navigate to {{ url.id }}">
                <mat-icon>open_in_new</mat-icon>
            </button>
            <div mat-line><strong> {{ url.id }} </strong></div>
            <div mat-line><input readonly=true matInput [(ngModel)]="url.value" /></div>
        </mat-list-item>
    </ng-container>
    <mat-divider></mat-divider>
    <br/>
</mat-list>